module.exports = __webpack_public_path__ + "static/media/director.c0ee12b2.png";